const selectPlatform = (subdomain) => {
    if(typeof subdomain === 'undefined' || subdomain === '' || subdomain === 'www') {
        return 'www'
    }
    return 'wg';
}

export default selectPlatform
